module.exports = __webpack_public_path__ + "img/pin.81736e97.svg";